const THREE = require('three')
import {TimelineMax, TweenMax, Cubic} from 'gsap'
import store from 'src/store'

export let scene = new THREE.Scene()
export default scene

import * as bg from './bg'
import * as flag from './flag'
import PlaneSprite from './plane-sprite'

// **************************************************
//
// MESH
//
// **************************************************
scene.add(bg.mesh)

export let content = new THREE.Object3D()
scene.add(content)
content.position.x = -10
// content.position.y = -35
content.add(flag.mesh)


// **************************************************
//
// TITLE
//
// **************************************************
const titleData = [
  {
    url: require('src/assets/result/shoe-zoom-title1.png'),
    size: 4957,
    x: 9,
    y: -70,
    z: 0
  },
  {
    url: require('src/assets/result/shoe-zoom-title2.png'),
    size: 16266,
    x: 9,
    y: -70,
    z: 0
  },
  {
    url: require('src/assets/result/shoe-zoom-title3.png'),
    size: 13331,
    x: 9,
    y: -70,
    z: 0
  }
]
let titleOffsets = [window.innerWidth * 1.3, window.innerHeight * 0.2, 0]
export let titles = []
for (let data of titleData) {
  let title = new PlaneSprite(data.url, data.size, 748, 219)
  titles.push(title)
  content.add(title)
  title.scale.setScalar(0.5)
  title.position.x = data.x + titleOffsets[0]
  title.position.y = data.y + titleOffsets[1]
  title.position.z = data.z + titleOffsets[2]

  title.material.depthTest = false
  title.material.depthWrite = false
}


// **************************************************
//
// SHOES
//
// **************************************************
const shoeData = [
  {
    url: require('src/assets/result/shoe-1.png'),
    size: 53335,
    x: -85,
    y: 15,
    z: 0,
    scale: 0.7
    // z: 170
  },
  {
    url: require('src/assets/result/shoe-2.png'),
    size: 51171,
    x: 10,
    y: 0,
    z: 0,
    scale: 0.8
    // z: 200
  },
  {
    url: require('src/assets/result/shoe-3.png'),
    size: 53435,
    x: 110,
    y: -15,
    z: 0,
    scale: 0.9
    // z: 230
  }
]
// let offset = [200, 500, 0]
let offset = [window.innerWidth * 1.2, window.innerHeight * 0.3, 0]
export let shoes = []
for (let data of shoeData) {
  let shoe = new PlaneSprite(data.url, data.size, 180, 200)
  shoe.scale.setScalar(data.scale)
  shoes.push(shoe)
  content.add(shoe)
  shoe.position.x = data.x + offset[0]
  shoe.position.y = data.y + offset[1]
  shoe.position.z = data.z + offset[2]
}



// **************************************************
//
// ANIMATION
//
// **************************************************
let tl

export let startShoesAnim = () => {
  tl = new TimelineMax()
  tl
    .to({}, 0.7, {})
    .to(flag.mesh.position, 0.6, {
      // z: -8 * THREE.Math.DEG2RAD,
      x: 10,
      y: -60,
      delay: 0.7,
      ease: Cubic.easeOut
    }, '-=0.7')
    .to(titles[0].position, 0.6, {
      x: titleData[0].x,
      y: titleData[0].y,
      z: titleData[0].z,
      ease: Cubic.easeOut
    }, '-=0.6')
    .to(titles[1].position, 0.6, {
      x: titleData[1].x,
      y: titleData[1].y,
      z: titleData[1].z,
      ease: Cubic.easeOut
    }, '-=0.5')
    .to(titles[2].position, 0.6, {
      x: titleData[2].x,
      y: titleData[2].y,
      z: titleData[2].z,
      ease: Cubic.easeOut
    }, '-=0.4')
    .to(shoes[0].position, 0.6, {
      x: shoeData[0].x,
      y: shoeData[0].y,
      z: shoeData[0].z,
      ease: Cubic.easeOut
    }, '-=0.7')
    .to(shoes[1].position, 0.6, {
      x: shoeData[1].x,
      y: shoeData[1].y,
      z: shoeData[1].z,
      ease: Cubic.easeOut
    }, '-=0.6')
    .to(shoes[2].position, 0.6, {
      x: shoeData[2].x,
      y: shoeData[2].y,
      z: shoeData[2].z,
      ease: Cubic.easeOut
    }, '-=0.5')
}

export const colorBgResult = () => {
  bg.draw('#E12D33')
}

export const animateIn = () => {
  startShoesAnim()
  return new Promise((resolve)=> {
    tl.onComplete = resolve
    // bg.draw('#E12D33')
    tl.restart()
  })
}

export const animateOut = () => {
  startShoesAnim()
  return new Promise((resolve)=> {
    tl.onComplete = resolve
    tl.reverse()
    bg.draw('rgba(255,255,255,0)', 0.6)
  })
}










// WEBPACK FOOTER //
// ./src/components/game/result/scene.js